import api from "../../../utils/api";
import { setAlert } from "../alert";
import { handleError } from "../errors";
import { CLIENT_BULK_ACTION_TIMESHEET, CLIENT_BULK_ACTION_TIMESHEET_ERROR, CLIENT_BULK_ACTION_TIMESHEET_INVOICE, CLIENT_BULK_ACTION_TIMESHEET_INVOICE_ERROR, DELETE_CLIENT_TIMESHEET_HOURS, DELETE_CLIENT_TIMESHEET_HOURS_ERROR, GENERATE_CLIENT_TIMESHEET_HOURS, GENERATE_CLIENT_TIMESHEET_HOURS_ERROR, GET_CLIENT_PROJECT_LIST, GET_CLIENT_PROJECT_LIST_ERROR, GET_CLIENT_TIMESHEET_BULK_LIST, GET_CLIENT_TIMESHEET_BULK_LIST_ERROR, GET_CLIENT_TIMESHEET_HOURS, GET_CLIENT_TIMESHEET_HOURS_ERROR, GET_CLIENT_TIMESHEET_ID, GET_CLIENT_TIMESHEET_ID_ERROR, GET_CLIENT_TIMESHEET_LIST, GET_CLIENT_TIMESHEET_LIST_ERROR, GET_CLIENT_TIMESHEET_STATUS_LIST, GET_CLIENT_TIMESHEET_STATUS_LIST_ERROR, GET_CLIENT_TIMESHEET_WORKER_RATES, GET_CLIENT_TIMESHEET_WORKER_RATES_ERROR, GET_SUB_PROJECT_LIST_ERROR, RESET_CLIENT_TIMESHEET_DETAILS, RESET_CLIENT_TIMESHEET_HOUR_DETAILS, SAVE_CLIENT_TIMESHEET, SAVE_CLIENT_TIMESHEET_ERROR, SAVE_CLIENT_TIMESHEET_HOURS, SAVE_CLIENT_TIMESHEET_HOURS_ERROR } from "../types";
import { redirect } from "../user";

export const get_client_timesheet_status_list = () => async (dispatch) => {
    try {
        const res = await api.get(`api/cli-timesheet/get-timesheet-status-list`);
        dispatch({
            type: GET_CLIENT_TIMESHEET_STATUS_LIST,
            payload: res.data,
        });
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_CLIENT_TIMESHEET_STATUS_LIST_ERROR,
        });
    }
};

export const get_client_timesheet_list = (refNum, worker, status, startDate, endDate, projectName) => async (dispatch) => {
    try {
        const res = await api.get(`api/cli-timesheet/get-timesheet-list`,
            {
                params: {
                    refNum: refNum,
                    workerName: worker,
                    status: status,
                    fromDate: startDate,
                    toDate: endDate,
                    projectName: projectName,
                }
            }
        );
        dispatch({
            type: GET_CLIENT_TIMESHEET_LIST,
            payload: res.data,
        });
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_CLIENT_TIMESHEET_LIST_ERROR,
        });
    }
};

export const get_client_bulk_action_list = () => async (dispatch) => {
    try {
        const res = await api.get(`api/cli-timesheet/get-bulk-action-list`);
        dispatch({
            type: GET_CLIENT_TIMESHEET_BULK_LIST,
            payload: res.data,
        });
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_CLIENT_TIMESHEET_BULK_LIST_ERROR,
        });
    }
};

export const client_bulk_action_timesheet_status = (bulkData) => async (dispatch) => {
    try {
        const res = await api.post(`api/cli-timesheet/bulk-update-timesheet-status`, bulkData)
        dispatch({
            type: CLIENT_BULK_ACTION_TIMESHEET,
            payload: true
        })
        dispatch(setAlert(res.data.message, 'success'))
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: CLIENT_BULK_ACTION_TIMESHEET_ERROR
        })
        return false;
    }
}

export const client_bulk_action_timesheet_invoice = (bulkData) => async (dispatch) => {
    try {
        const res = await api.post(`api/cli-timesheet/bulk-action-timesheet-invoice`, bulkData)
        dispatch({
            type: CLIENT_BULK_ACTION_TIMESHEET_INVOICE,
            payload: true
        })
        dispatch(setAlert(res.data.message, 'success'))
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: CLIENT_BULK_ACTION_TIMESHEET_INVOICE_ERROR
        })
        return false;
    }
}

export const delete_client_timesheet = (refNumList) => async (dispatch) => {
    try {
        const res = await api.post(`api/cli-timesheet/bulk-delete-timesheet`, refNumList);
        dispatch(setAlert(res.data.message, "success"))
        return true;
    } catch (err) {
        handleError(err, dispatch);
        return false;
    }
}

export const reset_client_timesheet_details = () => (dispatch) => dispatch({ type : RESET_CLIENT_TIMESHEET_DETAILS });

export const save_client_timesheet = (timesheet) => async (dispatch) => {
    try {
        const res = await api.post('api/cli-timesheet/save-timesheet', timesheet);
        dispatch(setAlert(res.data.message, 'success'))
        dispatch({
            type: SAVE_CLIENT_TIMESHEET,
            payload: res.data
        })
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({ type: SAVE_CLIENT_TIMESHEET_ERROR })
        return false;
    }
}

export const get_client_timesheet_by_refnum = (timesheetRefNum) => async (dispatch) => {
    try {
        const res = await api.get(`api/cli-timesheet/get-timesheet?refNum=${timesheetRefNum}`);
        dispatch({
            type: GET_CLIENT_TIMESHEET_ID,
            payload: res.data
        })

    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_CLIENT_TIMESHEET_ID_ERROR,
        });
    }
}

export const generate_client_timesheet_schedule = ( client, worker, endDate ) => async (dispatch) => {
    try {
        const res = await api.get(`api/cli-timesheet/generate-timesheet-schedule`, {
            params: {
                clientId: client,
                workerId: worker,
                payPeriodEndDate: endDate,
            }
        });
        dispatch({
            type: GENERATE_CLIENT_TIMESHEET_HOURS,
            payload: res.data,
        });
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GENERATE_CLIENT_TIMESHEET_HOURS_ERROR,
        });
        return false;
    }
};

export const get_client_timesheet_worker_rates = ( id ) => async (dispatch) => {
    try {
        const res = await api.get(`api/cli-timesheet/get-timesheet-rates?workerId=${id}`);
        dispatch({
            type: GET_CLIENT_TIMESHEET_WORKER_RATES,
            payload: res.data,
        });
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_CLIENT_TIMESHEET_WORKER_RATES_ERROR,
        });
        return false;
    }
};

export const delete_client_timesheet_hours = ( timesheeteRef , refNum ) => async (dispatch) => {
    try {
        const res = await api.get(`api/cli-timesheet/delete-timesheet-hours?timeSheetRefNum=${timesheeteRef}&refNum=${refNum}`);
        dispatch({
            type: DELETE_CLIENT_TIMESHEET_HOURS,
            payload: res.data,
        });
        dispatch(setAlert(res.data.message, "success"));
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: DELETE_CLIENT_TIMESHEET_HOURS_ERROR,
        });
        return false;
    }
};

export const get_client_timesheet_hours = ( timesheeteRef , refNum ) => async (dispatch) => {
    try {
        const res = await api.get(`api/cli-timesheet/get-timesheet-hours?timeSheetRefNum=${timesheeteRef}&refNum=${refNum}`);
        dispatch({
            type: GET_CLIENT_TIMESHEET_HOURS,
            payload: res.data,
        });
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_CLIENT_TIMESHEET_HOURS_ERROR,
        });
        return false;
    }
};

export const save_client_timesheet_hours = (timesheetHours) => async (dispatch) => {
    try {
        const res = await api.post('api/cli-timesheet/save-timesheet-hours', timesheetHours);
        dispatch(setAlert(res.data.message, 'success'))
        dispatch({
            type: SAVE_CLIENT_TIMESHEET_HOURS,
            payload: res.data
        })
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({ type: SAVE_CLIENT_TIMESHEET_HOURS_ERROR })
        return false;
    }
}

export const reset_client_timesheet_hour_details = () => (dispatch) => dispatch({ type : RESET_CLIENT_TIMESHEET_HOUR_DETAILS });

export const get_client_project_list = (name) => async (dispatch) => {
    try {
        const res = await api.get(`api/cli-project/project-list?clientId=${name}`);
        dispatch({
            type: GET_CLIENT_PROJECT_LIST,
            payload: res.data,
        });
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_CLIENT_PROJECT_LIST_ERROR,
        });
    }
};